@if (isEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    <div
      class="search-container"
      fxlayout="row"
      fxLayoutAlign="space-between center">
      <div style="width:100%">
        <topo-address-search
          [textarea]="true"
          [formField]="true"
          [expandable]="false"
          [width]="'100%'"
          [location]="selectedLocation"
        (searchResultChanged)="onSearchResultChanged($event)"></topo-address-search>
      </div>
      <div
        fxlayout="row"
        fxLayoutAlign="start center">
        @if (!!address) {
          <div
            class="mt-1 ml-2"
            [title]="'MAP.CLEAR-LOCATION' | translate"
            (click)="clearLocation()">
            <i class="icon icon-small_close-X"></i>
          </div>
        }
        <div
          class="mt-1 ml-1"
          [title]="'MAP.SET-LOCATION' | translate"
          (click)="setLocationFromMap()">
          <i class="icon icon-pin"></i>
        </div>
      </div>
    </div>
  </div>
}

@if (!isEdit && !!address) {
  <div
    class="field">
    <label class="upper">{{ displayName }}</label>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div>{{ address }}</div>
    </div>
  </div>
}
@if (showLocationSelection) {
  <topo-select-location
    [location]="selectedLocation"
    (saveLocation)="saveSelectLocation($event)"
  (cancelLocation)="cancelSelectLocation()"></topo-select-location>
}
